/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { EventType } from '@app/common/event/event-type';

export class Event {
  private readonly _name: string;
  private readonly _value: string;
  private readonly _type: EventType;

  constructor(name: string, value: string, type: EventType) {
    this._name = name;
    this._value = value;
    this._type = type;
  }

  get name(): string {
    return this._name;
  }

  get value(): string {
    return this._value;
  }

  get type(): EventType {
    return this._type;
  }
}
